import { blockUi } from "@bndes/bndes-ux4/bndes-angular-utils";
import { Observable } from 'rxjs';
import { Injectable } from "@angular/core";
import { FgiBackEndService } from "src/app/shared/fgi-back-end.service";
import { catchError } from 'rxjs/operators';
import { NaturezaJuridica } from 'src/app/model/natureza-juridica.model';

@Injectable({
  providedIn: 'root'
})
export class NaturezasJuridicasAceitasService extends FgiBackEndService<NaturezaJuridica>{

  getNewEntity() {
    return undefined;
  }

  protected getResourceURL(): string {
    return 'front/natureza-beneficiario';
  }

  public incluirCreditoLivre(ideTranche: string, dto: NaturezaJuridica): Observable<Array<NaturezaJuridica>> {
    const options = blockUi();
    return this.http.post(`${this.BASE_URL}/credito-livre/tranche/${ideTranche}`, dto, options).pipe
      (catchError((e) => this.handleError(e))) as Observable<Array<NaturezaJuridica>>
  }

  public incluirRepasse(ideTranche: string, dto: NaturezaJuridica): Observable<Array<NaturezaJuridica>> {
    const options = blockUi();
    return this.http.post(`${this.BASE_URL}/repasse-bndes/tranche/${ideTranche}`, dto, options).pipe
      (catchError((e) => this.handleError(e))) as Observable<Array<NaturezaJuridica>>
  }

  public buscarNaturezas(): Observable<any> {
    const options = blockUi();
    return this.http.get(`${this.BASE_URL}/repasse-bndes/naturezas`).pipe
      (catchError((e) => this.handleError(e))) as Observable<any>
  }

  public buscarRepasseBndes(ideTranche: number): Observable<Array<NaturezaJuridica>> {
    console.log(this.BASE_URL);
    const options = blockUi();
    return this.http.get(`${this.BASE_URL}/repasse-bndes/tranche/${ideTranche}`, options).pipe
      (catchError((e) => this.handleError(e))) as Observable<Array<NaturezaJuridica>>;

  }

  public excluirRepasse(ideTranche: string, ideNatureza: number): Observable<Array<NaturezaJuridica>> {
    const options = blockUi();
    return this.http.post(`${this.BASE_URL}/repasse-bndes/tranche/${ideTranche}/natureza/${ideNatureza}`, {}, options).pipe
      (catchError((e) => this.handleError(e))) as Observable<Array<NaturezaJuridica>>;
  }

  public buscarCreditoLivre(ideTranche: number): Observable<Array<NaturezaJuridica>> {
    console.log(this.BASE_URL);
    const options = blockUi();
    return this.http.get(`${this.BASE_URL}/credito-livre/tranche/${ideTranche}`, options).pipe
      (catchError((e) => this.handleError(e))) as Observable<Array<NaturezaJuridica>>;

  }

  public excluirCreditoLivre(ideTranche: string, ideNatureza: number): Observable<Array<NaturezaJuridica>> {
    const options = blockUi();
    return this.http.post(`${this.BASE_URL}/credito-livre/tranche/${ideTranche}/natureza/${ideNatureza}`, {}, options).pipe
      (catchError((e) => this.handleError(e))) as Observable<Array<NaturezaJuridica>>;
  }

}

